export default {
    packages_overview_title: "Paquete",
    packages_overview_platform: "Plataforma",
    packages_overview_activities: "Actividades",
    packages_overview_features: "Características",
    packages_overview_assigned_to: "Asignado a",
    packages_overview_description: "Descripción",
}